// extracted by mini-css-extract-plugin
module.exports = {"productIntroduction":"ProductIntroduction_productIntroduction__IA3lv","ef-box":"ProductIntroduction_ef-box__Chne1"};